import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  clientsTitle: {
    id: 'B2B.Brands.Title',
    defaultMessage: 'We’re trusted by leading companies',
  },
  heroHeader: {
    id: 'B2B.Home.Hero.Headline',
    defaultMessage: 'The infrastructure for the future of cross-border payments',
  },
  heroSubHeader: {
    id: 'B2B.Home.Hero.Description',
    defaultMessage:
      'A blockchain-based platform that connects to your business via a single and easy to integrate API.',
  },
  heroButton: {
    id: 'B2B.Home.Hero.CTA',
    defaultMessage: 'Contact us',
  },
  heroCards01Description: {
    id: 'B2B.Home.Hero.Feature_get',
    defaultMessage: 'Get direct connection to local banking rails.',
  },
  heroCards02Description: {
    id: 'B2B.Home.Hero.Feature_operate',
    defaultMessage: 'Operate with cost-effective transactions and reconciliation.',
  },
  heroCards03Description: {
    id: 'B2B.Home.Hero.Feature_reduce',
    defaultMessage: 'Reduce time-to-market and increase transparency.',
  },
  title: {
    id: 'B2B.Contact.Headline',
    defaultMessage: "Let's get in touch",
  },
  subtitle: {
    id: 'B2B.Contact.Description',
    defaultMessage:
      "Fill in the form with your personal and business information. We'll reach out to you as soon as possible.",
  },
  paymentsLatam: {
    id: 'B2B.Solutions.Title_payin',
    defaultMessage: 'Payments in Latam with a single integration',
  },
  payins: {
    id: 'B2B.Solutions.Hat_payin',
    defaultMessage: 'PAY-INS',
  },
  payouts: {
    id: 'B2B.Payins.Brazil.Features_built.82',
    defaultMessage: 'PAYOUTS',
  },
  titlePayouts: {
    id: 'B2B.Solutions.Title_payout',
    defaultMessage: 'Instant payments to customers and partners',
  },
  payoutsDescription: {
    id: 'B2B.Solutions.Description_payout',
    defaultMessage:
      'The fastest payments infrastructure built with blockchain technology and just one integration away.',
  },
  paymentsDescription: {
    id: 'B2B.Solutions.Description_payin',
    defaultMessage:
      'Reduce pay-in costs and decrease the time of moving funds. We have regulated entities across Latam and the US so you don’t need to open accounts in each country.',
  },
  paymentsAccessibility: {
    id: 'B2B.CrossBorder.Solutions.Container_24/7',
    defaultMessage: '24/7 accessibility for transactions: anytime, anywhere!',
  },
  paymentsTansactionSeconds: {
    id: 'B2B.CrossBorder.Solutions.Container_transactions',
    defaultMessage: 'Transaction in seconds!',
  },
  getInTouch: {
    id: 'B2B.Solutions.CTA',
    defaultMessage: 'Get in touch',
  },
  moreAboutPayins: {
    id: 'B2B.Solutions.Button_payin',
    defaultMessage: 'More about Pay-ins',
  },
  moreAboutPayouts: {
    id: 'B2B.Solutions.Button_payout',
    defaultMessage: 'More about Payouts',
  },
  businessHeading: {
    id: 'B2B.About.Headline',
    defaultMessage: 'Bitso Business',
  },
  secondaryHeroHat: {
    id: 'B2B.Solutions.Hat_api',
    defaultMessage: 'BOOST YOUR BUSINESS',
  },
  secondaryHeroHeader: {
    id: 'B2B.Solutions.Title_api',
    defaultMessage: 'One integration to scale your business with a robust infrastructure',
  },
  secondaryHeroDescription: {
    id: 'B2B.API.Hero.Description',
    defaultMessage: 'Seamless integration with your existing systems and infrastructure, reducing time to market.',
  },
  secondaryHeroButton: {
    id: 'B2B.Solutions.CTA',
    defaultMessage: 'Get in touch',
  },
  secondaryHeroTextButton: {
    id: 'B2B.Solutions.Button_api',
    defaultMessage: 'More about our APIs',
  },
  aboutUs: {
    id: 'B2B.About.Hat',
    defaultMessage: 'ABOUT US',
  },
  businessDescription: {
    id: 'B2B.About.Description',
    defaultMessage:
      'We are a payments infrastructure provider that enables global companies (and their customers) to pay and get paid in local currency and move money across borders.\n\nLeveraging blockchain-based technology, Bitso Business allows you to execute cost-effective and transparent transactions eliminating the need for pre-funding. Our platform is built on top of a single, easy-to-integrate API with direct connections to local banking rails, enabling instant local and cross-border transactions.\nAs we operate under a unique regulatory model, we are able to serve companies worldwide transacting across the United States, Mexico, Brazil, Colombia, and Argentina.',
  },
  securityEyebrow: {
    id: 'B2B.Security.Hat',
    defaultMessage: 'SECURITY AND REGULATION ARE OUR PRIORITIES',
  },
  securityTitle: {
    id: 'B2B.Security.Headline',
    defaultMessage: 'Your gateway to safe and regulated business expansion',
  },
  securityDescription: {
    id: 'B2B.Security.Description',
    defaultMessage:
      "We're the first exchange in Latin America with end-to-end regulatory coverage. We're licensed in Europe and across Latam.",
  },
  regulatoryLicenses: {
    id: 'B2B.Security.Title_licenses',
    defaultMessage: "Bitso's regulatory licenses",
  },
  arLicense: {
    id: 'B2B.Security.Description_argentina',
    defaultMessage:
      'Nvio operates as a regulated entity under a Payments Service Provider (PSP) license, under the regulation of the Central Bank.',
  },
  brLicense: {
    id: 'B2B.Security.Description_brazil',
    defaultMessage:
      'Nvio operates as a regulated entity under both Instituiçao de Pagamento license and S.C.D license under the regulation of the Central Bank.',
  },
  mxLicense: {
    id: 'B2B.Security.Description_mexico',
    defaultMessage:
      'Nvio operates as a regulated entity under the supervision of the National Banking and Stocks Commission (CNBV) and as an Electronic Payment Fund Institution (IFPE).',
  },
  coLicense: {
    id: 'B2B.Security.Description_colombia',
    defaultMessage:
      'Bitso was authorized by the Financial Superintendency of Colombia to operate under the regulatory sandbox testing.',
  },
  usLicense: {
    id: 'B2B.Security.Description_gibraltar',
    defaultMessage:
      'First Latin American platform in obtaining Distributed Ledger Technology Regulatory Framework from the Gibraltar Financial Services Commission (GFSC). We have a robust regulatory framework with strong focus in AML and asset protection. Deposits, trades and withdrawals are under supervision of the GFSC.',
  },
  mxCountryName: {
    id: 'B2B.Security.Title_mexico',
    defaultMessage: 'Mexico',
  },
  arCountryName: {
    id: 'B2B.Security.Title_argentina',
    defaultMessage: 'Argentina',
  },
  coCountryName: {
    id: 'B2B.Security.Title_colombia',
    defaultMessage: 'Colombia',
  },
  brCountryName: {
    id: 'B2B.Security.Title_brazil',
    defaultMessage: 'Brazil',
  },
  usCountryName: {
    id: 'B2B.Security.Title_gibraltar',
    defaultMessage: 'Gibraltar',
  },
  sectionTitle: {
    id: 'B2B.Solutions.Headline',
    defaultMessage: 'Our solutions for your business',
  },
  crossBorderPaymentsHat: {
    id: 'B2B.CrossBorder.Hero.Hat',
    defaultMessage: 'CROSS-BORDER PAYMENTS',
  },
  crossBorderPaymentsTitle: {
    id: 'B2B.Solutions.Title_cross',
    defaultMessage: 'Move money across borders  in real time',
  },
  crossBorderPaymentsDescription: {
    id: 'B2B.Solutions.Description_cross',
    defaultMessage:
      'A cost-effective solution for settlements across borders in multiple currencies: fiat to stablecoin, fiat to fiat or stablecoin to fiat options.',
  },
  crossBorderPaymentsButton: {
    id: 'B2B.Solutions.Button_cross',
    defaultMessage: 'More about Cross-border payments',
  },
  tradeTitle: {
    id: 'B2B.Solutions.Title_trading',
    defaultMessage: 'Assets to trade and exchange',
  },
  tradeDescription: {
    id: 'B2B.Trading.Hero.Description',
    defaultMessage:
      'Make large transactions easily with our Over-the-Counter (OTC) services, tailored for those dealing with substantial amounts.',
  },
  tradeHat: {
    id: 'B2B.Solutions.Hat_trading',
    defaultMessage: 'Trading & OTC SERVICES',
  },
  tradeMoreButton: {
    id: 'B2B.Solutions.Button_trading',
    defaultMessage: 'More about Trading & OTC',
  },
  businessSEOTitle: {
    id: 'B2B.Meta.Title',
    defaultMessage: 'Payments Infrastructure with blockchain-based technology',
  },
  businessSEODescription: {
    id: 'B2B.Meta.Description',
    defaultMessage:
      'Leverage our Pay-ins and Payouts in Latin America, Cross-Border payments, Trading and OTC services to grow your business with a fully regulated partner.',
  },
  seeMoreTitle: {
    id: 'B2BSite.AboutUs.SolutionsSection.Title',
    defaultMessage: 'Our transformative solutions',
  },
  seeMorePayinsTitle: {
    id: 'B2B.Solutions.Hat_payin',
    defaultMessage: 'Pay-ins',
  },
  seeMorePayoutsTitle: {
    id: 'B2B.Solutions.Hat_payout',
    defaultMessage: 'Payouts',
  },
  seeMoreCrossBorderTitle: {
    id: 'B2B.Solutions.Hat_cross',
    defaultMessage: 'Cross-border payments',
  },
  seeMoreKnowMore: {
    id: 'B2BSite.AboutUs.LinkSection.Link',
    defaultMessage: 'Know more',
  },
});
